import { useQuery } from '@tanstack/react-query';
import { clientAnalyticsService } from '@/services/clientAnalyticsService';

// The endpoint requires period_start and period_end. Default to the last ~90
// days so a caller that passes no dates still gets a valid request.
function defaultPeriod(): { period_start: string; period_end: string } {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - 90);
  const iso = (d: Date) => d.toISOString().slice(0, 10);
  return { period_start: iso(start), period_end: iso(end) };
}

// Loads the per-client analytics dashboard. The tenant/website is the query
// key, so switching clients refetches. Not a polling endpoint — analytics data
// refreshes daily, so a long staleTime avoids needless refetches.
export function useClientAnalytics(
  website: string,
  params?: { period_start?: string; period_end?: string },
) {
  const period = { ...defaultPeriod(), ...params };
  return useQuery({
    queryKey: ['client-analytics', website, period.period_start, period.period_end],
    queryFn: () => clientAnalyticsService.getDashboard(website, period),
    enabled: !!website,
    staleTime: 5 * 60_000,
    retry: 1,
  });
}
